"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var index_1 = require("../../classic/index");
var ChangeLanguage_1 = require("./ChangeLanguage");
var Copyright_1 = __importDefault(require("./Copyright"));
var FooterMenu_1 = __importDefault(require("./FooterMenu"));
var InFooterCompanies_1 = __importDefault(require("./InFooterCompanies"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FooterFlat = function (_a) {
    var restrictedLicenseCountries = _a.restrictedLicenseCountries, footerMenu = _a.footerMenu, languages = _a.languages, _b = _a.License, License = _b === void 0 ? null : _b, _c = _a.LicenseWidget, LicenseWidget = _c === void 0 ? null : _c, firstBonus = _a.firstBonus, _d = _a.showSignUp, showSignUp = _d === void 0 ? true : _d;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var pathname = (0, navigation_1.usePathname)();
    var config = (0, swr_hooks_1.useConfig)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var footerHead = (0, react_1.useMemo)(function () {
        return footerMenu.head
            ? footerMenu.head
            : [
                {
                    link: "/promotions",
                    linkName: 'promotions',
                },
                {
                    link: "/payments",
                    linkName: 'payments',
                },
                {
                    link: "/tournaments",
                    linkName: 'tournaments',
                },
                {
                    link: "/vip",
                    linkName: 'vipclub',
                },
            ];
    }, [footerMenu.head]);
    var footerLinks = (0, react_1.useMemo)(function () { return __spreadArray(__spreadArray([], footerHead, true), footerMenu.games, true); }, [footerHead, footerMenu.games]);
    if (pathname.includes('game-not-available')) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    // @ts-ignore
    return !pathname.includes('/game/') ? (react_1.default.createElement("footer", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container, style: { paddingBottom: !isAuth ? '60px' : '0' } },
            react_1.default.createElement(InFooterCompanies_1.default, null),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.mainFooter },
                !breakpoints.mobile && !breakpoints.tablet && (react_1.default.createElement("div", { className: styles_module_scss_1.default.footerLinkTop }, footerLinks.map(function (item) { return (react_1.default.createElement("a", { href: generateUrlWithLang(item.link), key: item.linkName }, t("".concat(item.linkName)))); }))),
                react_1.default.createElement(FooterMenu_1.default, { languages: languages, footerMenu: footerMenu, restrictedLicenseCountries: restrictedLicenseCountries, LicenseWidget: LicenseWidget }),
                react_1.default.createElement(ChangeLanguage_1.ChangeLanguage, { languages: languages, variant: "round", isAuth: false }),
                react_1.default.createElement(Copyright_1.default, { restrictedLicenseCountries: restrictedLicenseCountries, License: License }))),
        !(config === null || config === void 0 ? void 0 : config.hideAcceptCookies) ? react_1.default.createElement(index_1.AcceptCookies, null) : null,
        react_1.default.createElement(index_1.GetBonusPanel, { firstBonus: firstBonus, showSignUp: showSignUp }),
        react_1.default.createElement(index_1.MobileAuthButtons, { showSignUp: showSignUp }))) : null;
};
exports.default = FooterFlat;
